import {Brick, ErrorFlow, registerBrick, Service} from 'olympe';
import {USER_SERVICE_TOPICS} from '../../services/service_api/CreateUserService.brick';

/**
 * This brick is responsible for unlocking all purchase requests by using the user service topic.
 */
export default class UnlockAllPRs extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     * @param {function(ErrorEvent)} setErrorFlow
     */
    update($, inputs, [forwardEvent, setErrorFlow]) {
        Service.publish('userService', ({topic: USER_SERVICE_TOPICS.UNLOCK_ALL_PRS}))
            .then(() => {
                forwardEvent();
            })
            .catch((e) => {
                setErrorFlow(ErrorFlow.create(`Error while unlocking the PRs ${e}`, 1));
            });
    }
}

registerBrick('0198d21272aa3ad679eb', UnlockAllPRs);
